import type { Country } from '@tenders/shared';
import { countryConfig } from '../country';
import { BUILD_COUNTRY } from '../lib/build-country';

/**
 * Does this deployment have a guide at all? Liciora (Chile) has none written yet:
 * its `/guide` and `/guide/<slug>` redirect to the catalogue, nothing links to
 * them and the prerender and sitemap leave them out — a Chilean reader must never
 * land on the Spanish (LCSP/BOE) or the Uzbek guide. `true` on UZ, KZ and ES.
 * On `BUILD_COUNTRY`, so the cl bundle carries no guide content at all.
 */
export const GUIDE_ON: boolean = BUILD_COUNTRY !== 'cl';

/**
 * Where a lot page's «how to submit your offer» link (`tender.participateHint`)
 * leads. UZ and KZ keep the `/guide` hub, exactly as before. Spain points it at the
 * step-by-step article, which covers both halves of its label («Cómo presentar tu
 * oferta y obtener el certificado digital»).
 *
 * Kept OUT of `guide-articles/index.ts` on purpose: that registry imports every
 * article body (code-split away from the lot page), and this is read on every lot.
 * `guide-articles/es-guide.test.tsx` pins that the Spanish slug is registered.
 */
const HOWTO_PATH: Partial<Record<Country, string>> = {
  es: '/guide/como-participar-en-licitaciones-publicas',
};

export const GUIDE_HOWTO_PATH: string = HOWTO_PATH[countryConfig.code] ?? '/guide';
